var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "animationload" }, [
      _c("div", { staticClass: "circle-border" }, [
        _c("div", { staticClass: "circle-core" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/loading.vue?vue&type=template&id=24a16d5c&scoped=true&
// module id = null
// module chunks = 